/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SiteNavItem_navigationModule = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SiteNavItem_navigationModule",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNavDropdownContent_navigationModule",
      "args": null
    }
  ],
  "type": "NavigationModule"
};

module.exports = fragment;
